import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentModal } from './PaymentModal';
import './BuyCreditsButton.css';

export const BuyCreditsButton = ({ className = '' }) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <button
        className={`buy-credits-button ${className}`}
        onClick={() => setIsModalOpen(true)}
      >
        {t('buyCredits.buy')}
      </button>

      <PaymentModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
}; 